/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobForwardingCheckResponse {
    getFixupPrototypeFunction() { return BackgroundJobForwardingCheckResponse.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobForwardingCheckResponse>): BackgroundJobForwardingCheckResponse {
        let obj = Object.assign(new BackgroundJobForwardingCheckResponse(), model);
        BackgroundJobForwardingCheckResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobForwardingCheckResponse>): BackgroundJobForwardingCheckResponse {
        if (!model) return null;
        return BackgroundJobForwardingCheckResponse.newInstance(<BackgroundJobForwardingCheckResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobForwardingCheckResponse) {
        if (!obj) return;

        models.BackgroundJobForwardingCheckResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobForwardingCheckResponse): boolean {
        Object.setPrototypeOf(obj, BackgroundJobForwardingCheckResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.hops === undefined) {
            this.hops = 0;
        }
    }

    /**
     * Number of hops to react executor
     */
    hops: number;

}
